import { render, staticRenderFns } from "./PeledakanViewEmail.vue?vue&type=template&id=24c8bee3&scoped=true&lang=pug&"
import script from "./PeledakanViewEmail.vue?vue&type=script&lang=js&"
export * from "./PeledakanViewEmail.vue?vue&type=script&lang=js&"
import style0 from "./PeledakanViewEmail.vue?vue&type=style&index=0&id=24c8bee3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c8bee3",
  null
  
)

export default component.exports